<mat-accordion class="d-flex flex-column" displayMode="flat" [multi]="true">
    <mat-expansion-panel class="view-expansion-panel" [expanded]="true">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Programare</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
            <div class="p-0">
                <app-appointment [appointment]="appointment" [cerere]="cerere"></app-appointment>
            </div>

            <ng-container *ngIf="cerere.programare">
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle> Locație </span>
                    <span matListItemLine> {{ cerere.programare.denumire_locatie }} </span>
                </mat-list-item>
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle> Serviciu </span>
                    <span matListItemLine> {{ cerere.programare.denumire_serviciu }} </span>
                </mat-list-item>
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle> Tip program </span>
                    <span matListItemLine> {{ cerere.programare.denumire_program_type }} </span>
                </mat-list-item>
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle> Tip problemă </span>
                    <span matListItemLine> {{ cerere.denumire_problem_type }} </span>
                </mat-list-item>
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Data programării
                    </span>
                    <span matListItemLine>
                        {{ cerere.programare.date }}
                    </span>
                </mat-list-item>
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Ora programării
                    </span>
                    <span matListItemLine>
                        {{ cerere.programare.time_from }}
                    </span>
                </mat-list-item>
            </ng-container>
        </mat-list>
    </mat-expansion-panel>

    <mat-expansion-panel class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Date de contact</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Nume
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.nume || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Prenume
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.prenume || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    {{ cerere.cetatean?.persoana_type === 1 ? "CNP" : "CUI" }}
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.cnp || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Email
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.email || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Telefon
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.telefon || '&nbsp;' }}
                </span>
            </mat-list-item>
        </mat-list>
    </mat-expansion-panel>

    <mat-expansion-panel class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Solicitare</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    ID Responsabil
                </span>
                <span matListItemLine>
                    {{ cerere.id_user_assigned || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Responsabil
                </span>
                <span matListItemLine>
                    {{ cerere.user_assigned || '&nbsp;' }}
                </span>
            </mat-list-item>
        </mat-list>
    </mat-expansion-panel>
</mat-accordion>